/* eslint-disable */

import request from '@/utils/request'

export function getMarketSegmentApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group/market-seg',
    method: 'get',
    params: query
  })
}

export function addMarketSegmentApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group/market-seg',
    method: 'post',
    data: query
  })
}

export function updateMarketSegmentApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group/market-seg',
    method: 'put',
    data: query
  })
}
export function deleteMarketSegmentApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group',
    method: 'delete',
    data: query
  })
}
